"use client";
import { useAuiState } from "@assistant-ui/store";
export const ThreadPrimitiveEmpty = ({ children, }) => {
    const empty = useAuiState(({ thread }) => thread.messages.length === 0 && !thread.isLoading);
    return empty ? children : null;
};
ThreadPrimitiveEmpty.displayName = "ThreadPrimitive.Empty";
//# sourceMappingURL=ThreadEmpty.js.map